import React from 'react'

import { Helmet } from 'react-helmet'

const ContactPage = () => (
  <React.Fragment>
    <Helmet>
      <title>Contact Us</title>
    </Helmet>

    <h2>Contact Us</h2>
    <p>
      Please email us at{' '}
      <a href="mailto:info@artisticcoffee.com">info@artisticcoffee.com</a>.
    </p>
  </React.Fragment>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js